// extracted by mini-css-extract-plugin
export default {"btnWrapper":"Button_btnWrapper__Li37s","deleteButton":"Button_deleteButton__hjlo+","saveButton":"Button_saveButton__3CHc4"};